/*
 * @Author: Sephiroth·D·Kid
 * @LastEditors: Sephiroth·D·Kid
 * @Description: 请求统一拦截器
 * @Date: 2019-04-22 10:03:10
 * @LastEditTime: 2019-10-18 17:23:49
 */

import axios from 'axios';

// 创建实例
const service = axios.create({
	timeout: 30000, // 请求超时时间
	withCredentials: false, // 默认的 true: 已formData形势提交数据时，该项要注掉或者设置为false
	headers: {},
});
service.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.xinghuazl.com' : 'http://192.168.29.21:10001'

// request 拦截器
service.interceptors.request.use(
	config => {
		return config;
	},
	error => {
		return Promise.reject(error);
	},
);

// respone 拦截器
service.interceptors.response.use(
	response => {
		return response.data;
	},
	error => {
		let errorInfo = {};
		if (error.response) {
			errorInfo.errCode = error.response.status;
		}
		return Promise.resolve(errorInfo);
	}
);

export default service;